import SecondaryDefaultButton from '@/components/buttons/secondary/DefaultButton';
import SecondaryInnerGlowButton from '@/components/buttons/secondary/InnerGlowButton';
import SecondaryOuterGlowButton from '@/components/buttons/secondary/OuterGlowButton';

export default SecondaryDefaultButton;

export { SecondaryDefaultButton, SecondaryInnerGlowButton, SecondaryOuterGlowButton };
